import { Text, mergeStyleSets } from "@fluentui/react";

const styles = mergeStyleSets({
    backToTop: {
        fontSize: 13,
        textAlign: "right" as const,
        marginTop: 8,
    },
});

export default function BackToTop() {
    return (
        <Text className={styles.backToTop} block>
            <a href="#scoreboard-top" onClick={(e) => { e.preventDefault(); document.getElementById("scoreboard-top")?.scrollIntoView({ behavior: "smooth" }); }}>Back to top</a>
        </Text>
    );
}